export default "/images/veeva.svg?fdee267ad3314603b8cf0b1d1a36a848";